export default __webpack_public_path__ + "static/media/waterfall& raindrops.b3a915bc.jpg";